import {
  api,
  ResourcePage,
  responseErrorCheck,
  SimpleReadingList,
  SimpleReadingListBatchValidateRes,
  SimpleReadingListEntry,
  SimpleReadingListStartReq,
  TmrBaseResource,
  TmrSimpleAttributesMap
} from 'stylewhere/api'
import { AppStore, SimpleReadingListOperationConfig } from 'stylewhere/shared'

interface ConfirmReq {
  operationId: string
  simpleReadingListId: string
  attributes?: TmrSimpleAttributesMap
}

export class SimpleReadingLists extends TmrBaseResource {
  static operationEndpoint = `api/v1/operations/simpleReadingList` // logistics
  static endpoint = `api/v1/simpleReadingLists`

  static getSimpleReadingLists(searchParams: any = {}): Promise<ResourcePage<SimpleReadingList>> {
    return api.get(`${this.endpoint}`, searchParams).then(responseErrorCheck)
  }

  static start(startReq: SimpleReadingListStartReq): Promise<SimpleReadingList> {
    return api.post(`${this.operationEndpoint}/start`, startReq).then(responseErrorCheck)
  }

  static batchValidate(data?: any): Promise<SimpleReadingListBatchValidateRes> {
    return api.post(`${this.operationEndpoint}/batchValidate`, data).then(responseErrorCheck)
  }

  static getEntries(
    simpleReadingListId: string,
    searchParams: any = {}
  ): Promise<ResourcePage<SimpleReadingListEntry>> {
    return api.get(`${this.operationEndpoint}/${simpleReadingListId}/entries`, searchParams).then(responseErrorCheck)
  }

  static updateReadings(updateReq: any): Promise<void> {
    return api.post(`${this.operationEndpoint}/updateReadings`, updateReq).then(responseErrorCheck)
  }

  static confirm(confirmReq: ConfirmReq): Promise<SimpleReadingList> {
    return api.post(`${this.operationEndpoint}/confirm`, confirmReq).then(responseErrorCheck)
  }

  static executeAction(operation: SimpleReadingListOperationConfig, listId: string, actionCode: string, payload: any) {
    const fullPayload = {
      operationId: operation.id,
      actionCode: actionCode,
      attributes: {},
      ...payload
    }
    fullPayload.attributes.workstationCode = AppStore.defaultWorkstation?.code
    return api.post(`${this.operationEndpoint}/${listId}/executeAction`, fullPayload).then(responseErrorCheck)
  }
}
